import styled from "styled-components";

// ── Styled Components ────────────────────────────────────────────────────────

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
`;

const Select = styled.select`
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #1e293b;
  color: #e2e8f0;
  font-size: 13px;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #38bdf8;
  }

  &:hover {
    border-color: #94a3b8;
  }
`;

// ── Component ────────────────────────────────────────────────────────────────

export default function LayoutSelector({ handleSelectedLayout, layouts, selected }) {
  return (
    <Wrapper>
      <Label htmlFor="layout">Layout:</Label>
      <Select
        id="layout"
        value={selected}
        onChange={(e) => handleSelectedLayout(e.target.value)}
      >
        {Object.values(layouts).map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </Select>
    </Wrapper>
  );
}